import axios, { AxiosError, HttpStatusCode } from 'axios'
import { API_URL } from '../../constants'
import { getRecoil, setRecoil } from 'recoil-nexus'
import { currentTokenState, incrementRefreshCounter, useRefreshToken } from 'services/auth'
import { BaseErrorResponse } from './types'

const http = axios.create({
  baseURL: API_URL,
  withCredentials: false,
})

// set current access token to each request.
http.interceptors.request.use(
  async (cfg) => {
    const token = getRecoil(currentTokenState)

    cfg.headers.Authorization = token.access

    return cfg
  },
  (err) => Promise.reject(err)
)

// if something wrong with token redirect user to login page.
http.interceptors.response.use(
  (res) => res,
  async (err: AxiosError<BaseErrorResponse>) => {
    if (err.response?.status === HttpStatusCode.Unauthorized) {
      try {
        const isLimited = getRecoil(incrementRefreshCounter)
        if (isLimited) {
          setRecoil(incrementRefreshCounter, true)
          return await Promise.reject(err)
        }
        const { refreshToken } = useRefreshToken()

        const token = getRecoil(currentTokenState)
        setRecoil(incrementRefreshCounter, false)

        const refreshedToken = await refreshToken(token.refresh)
        setRecoil(currentTokenState, {
          access: refreshedToken.accessToken,
          refresh: refreshedToken.refreshToken,
        })
        err.config.headers.Authorization = refreshedToken.accessToken
        return await http(err.config)
      } catch (error) {
        return Promise.reject(err)
      }
    }

    return Promise.reject(err)
  }
)

export default http
